module.exports = __webpack_public_path__ + "img/voortuin Luts na.67b0fbbd.jpg";